// src/hooks/useLinkPreviews.ts — loader for the owner console's Link previews
// panel (1.24.00 F1): `GET /owner/link-previews/`. Same shape as every other
// owner aggregate loader ({data, loading, error, refetch}); the section calls
// refetch after each write so the switch state and the counters are the
// server's, never an optimistic guess.
import { ownerService } from '@/core/services/ownerService';
import { useOwnerList } from './useOwnerList';
import type { LinkPreviewState } from '@/core/models';

export function useLinkPreviews() {
  return useOwnerList<LinkPreviewState>(() => ownerService.getLinkPreviews());
}
